// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media(min-width:992px){
   html[dir='ltr'] .face-injection-juvelook .container{
        padding-left: 176px;
        padding-right: 0;
    }
    html[dir='rtl'] .face-injection-juvelook .container{
        /* padding-right: 88px; */
        padding-right: 176px;

        padding-left: 0;
        margin-left: 0!important;
    }
}
@media(min-width:768px) and (max-width:991px) {
    html[dir='ltr'] .face-injection-juvelook .container{
        padding-left: 96px!important;
        padding-right: 0!important;
    }
    html[dir='rtl'] .face-injection-juvelook .container{
        padding-right: 96px!important;
        padding-left: 0!important;
    }
    
    .mark-svg svg {
        width: 15px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/brands/components/FaceInjectionPointsJuvelook.css"],"names":[],"mappings":"AAAA;GACG;QACK,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,yBAAyB;QACzB,oBAAoB;;QAEpB,eAAe;QACf,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,4BAA4B;QAC5B,0BAA0B;IAC9B;IACA;QACI,6BAA6B;QAC7B,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":["@media(min-width:992px){\n   html[dir='ltr'] .face-injection-juvelook .container{\n        padding-left: 176px;\n        padding-right: 0;\n    }\n    html[dir='rtl'] .face-injection-juvelook .container{\n        /* padding-right: 88px; */\n        padding-right: 176px;\n\n        padding-left: 0;\n        margin-left: 0!important;\n    }\n}\n@media(min-width:768px) and (max-width:991px) {\n    html[dir='ltr'] .face-injection-juvelook .container{\n        padding-left: 96px!important;\n        padding-right: 0!important;\n    }\n    html[dir='rtl'] .face-injection-juvelook .container{\n        padding-right: 96px!important;\n        padding-left: 0!important;\n    }\n    \n    .mark-svg svg {\n        width: 15px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
